import { render, staticRenderFns } from "./TitleHomeComponent.vue?vue&type=template&id=bf94fb54&scoped=true"
import script from "./TitleHomeComponent.vue?vue&type=script&lang=js"
export * from "./TitleHomeComponent.vue?vue&type=script&lang=js"
import style0 from "./TitleHomeComponent.vue?vue&type=style&index=0&id=bf94fb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94fb54",
  null
  
)

export default component.exports